export const CoSyncCenterEvent = {
  onWorkerCmd: 'onWorkerCmd', //  worker进程通知执行命令
  onTaskStatusChange: 'onTaskStatusChange', // 更新同步任务的状态
  onTaskStatusMapChange: 'onTaskStatusMapChange', // 同步任务Map中出现状态更新
  onTaskRemove: 'onTaskRemove', // 同步任务被移除通知
};
